// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { DataTableAjaxComponent } from './../../../shared/data-table-ajax/data-table-ajax.component';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { tap, merge } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTimePipe } from '../../date-time.pipe';
import { Group } from '../../core/models/groups.model';
import { GroupFacadeService } from '@app/access-management/state/groups/group.facade';
import { LoadingStatus } from '@app/core';
import { Subject } from 'rxjs';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { GroupsService } from '@app/access-management/core/services/group.service';

@Component({
  selector: 'app-groups-list',
  templateUrl: './groups-list.component.html',
  styleUrls: ['./groups-list.component.scss']
})
export class GroupsListComponent implements OnInit, AfterViewInit {
  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('dataTableAjax') dataTableAjax: DataTableAjaxComponent | undefined;

  LOAD_COMPLETE = LoadingStatus.LOAD_COMPLETE;
  columns: any[] = [];

  currentPageNumber = 0;
  filteredList$ = new Subject();
  tableList$: any;
  fullList = [];

  constructor(
    public groupFacade: GroupFacadeService,
    private groupService: GroupsService,
    private modalService: NgbModal
  ) {
    this.groupFacade.initializeGroup();
  }

  ngAfterViewInit() {
    this.loadTableColumns();
  }

  loadTableColumns() {
    this.columns = [
      {
        name: 'Group Name',
        prop: 'group_name',
        cellClass: 'text-info',
        flexGrow: 1
      },
      {
        name: 'Description',
        prop: 'description',
        flexGrow: 1
      },
      {
        name: 'Organization Name',
        prop: 'account_name',
        flexGrow: 1
      },
      {
        name: 'Created',
        prop: 'created_at',
        pipe: new DateTimePipe('en'),
        flexGrow: 1
      },
      {
        name: 'Edited',
        prop: 'updated_at',
        pipe: new DateTimePipe('en'),
        flexGrow: 1
      },
      {
        name: 'Actions',
        prop: 'id',
        cellTemplate: this.actionTemplate,
        sortable: false,
        flexGrow: 1
      }
    ];
  }

  selectRow(data: { [selected: string]: Group[] }) {
    if (data.selected.length < 1) {
      return;
    }
    const row = data.selected[0];
    this.groupFacade.goToGroupDetail(row);
  }

  onRemoveRow(removedId: string) {
    const ModalFixture = this.modalService.open(GeneralDeleteModalComponent, {
      centered: true,
      windowClass: 'no-border'
    });
    const modal: GeneralDeleteModalComponent = ModalFixture.componentInstance;

    modal.observable = this.groupService.deleteGroup(removedId);

    modal.onSuccessRemove = () => {
      this.groupFacade.removeGroupSucceed(removedId);
      modal.close();
      this.refreshTable();
    };

    modal.onFailRemove = () => {
      this.groupFacade.removeGroupFailed();
    };
  }

  refreshTable() {
    if (this.dataTableAjax) {
      this.dataTableAjax.refreshTable();
    }
  }

  trackColumns(idx: number) {
    return idx;
  }

  onEditClick(row: any) {
    this.groupFacade.goToEditGroup(row);
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/access-management/groups/groups-list/groups-list.component.ts